type NavItem = {
  key: string;
  path: string;
  title: string;
};

export const filterNavItems = (
  items: NavItem[],
  allowedPages?: Record<string, boolean>
) => {
  if (!allowedPages) return items;

  return items.filter((item) => {
    const allowed = allowedPages[item.key];
    return allowed === undefined || allowed === true;
  });
};
